import React from 'react'
import Svg from './Svg'
export const SvgNavCaret = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M8.5 9.8l6.6 2.6-6.6 2.5z" />
  </Svg>
))
SvgNavCaret.isIcon = true
export default SvgNavCaret
